export default function getCreatorsNames(creators) {
  if (!creators?.find((creator) => creator?.name)) return null

  const creatorsNames = creators?.map((creator) => (creator?.name ? creator.name : null))
  return creatorsNames.join(', ')
}
